"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Modal_1 = __importDefault(require("@mui/material/Modal"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var react_device_detect_1 = require("react-device-detect");
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var EditAndSaveButtons_1 = __importDefault(require("../EditAndSaveButtons"));
var WaveTitle = btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"452.607\" height=\"90\" viewBox=\"0 0 452.607 90\">\n    <path id=\"PopinTitre_Droite\" d=\"M264.5,90V1H716.579c-61.563,3.622-113.39,13.924-137.873,28.127L524.684,60.451C493.9,78.307,419.881,90,337.629,90Z\" transform=\"translate(-264.001 -0.499)\" fill=\"#fafcfc\" stroke=\"#dbe3ec\" stroke-miterlimit=\"10\" stroke-width=\"1\"/>\n  </svg>");
function PopIn(_a) {
    var title = _a.title, onClose = _a.onClose, children = _a.children, footer = _a.footer, sx = _a.sx, id = _a.id, nextSync = _a.nextSync, hideClose = _a.hideClose, overflow = _a.overflow, genericSaveButtons = _a.genericSaveButtons;
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, __assign({ open: true, sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiBox-root': {
                maxWidth: react_device_detect_1.isMobileOnly ? '100%' : '1500px',
            },
            width: react_device_detect_1.isMobileOnly ? '100%' : 'auto',
        }, componentsProps: {
            backdrop: {
                style: {
                    backdropFilter: 'blur(12px)',
                    backgroundColor: 'rgba(4, 30, 57, 0.75)',
                },
            },
        }, onClose: onClose }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ sx: __assign(__assign({ backgroundColor: 'background.default', borderRadius: react_device_detect_1.isMobileOnly
                    ? '0px 0px 0px 0px'
                    : '20px 20px 20px 20px', minHeight: react_device_detect_1.isMobileOnly ? '100%' : '400px', display: 'flex', flexDirection: 'column' }, sx), { maxHeight: '90vh', maxWidth: '90vh' }) }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ sx: {
                        height: '72px',
                        backgroundColor: 'transparent',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        zIndex: 2,
                    } }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ sx: {
                                height: '72px',
                                width: react_device_detect_1.isMobileOnly ? '100%' : 'auto',
                                backgroundColor: 'primary.dark',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: react_device_detect_1.isMobileOnly
                                    ? '0px 0px 0px 0px'
                                    : '20px 0px 0px 0px',
                                borderWidth: '0px',
                                borderBottomWidth: '1px',
                                borderStyle: 'solid',
                                borderColor: '#dbe3ec',
                                zIndex: 2,
                                paddingLeft: '49px',
                            } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "h1" }, { children: title })), react_device_detect_1.isMobileOnly && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: { flex: 1 } }), (0, jsx_runtime_1.jsx)(Close_1.default, { "data-testid": "closePopin", sx: {
                                                color: 'text.secondary',
                                                marginRight: '40px',
                                                cursor: 'pointer',
                                            }, onClick: onClose, fontSize: "medium" })] }))] })), !react_device_detect_1.isMobileOnly && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { component: "img", src: "data:image/svg+xml;base64,".concat(WaveTitle), sx: {
                                        marginLeft: '-80px',
                                        height: '72px',
                                        width: 'auto',
                                    } }), (0, jsx_runtime_1.jsx)("div", { style: { flex: 1 } }), (0, jsx_runtime_1.jsx)(Close_1.default, { "data-testid": "closePopin", sx: {
                                        color: hideClose ? 'transparent' : 'text.secondary',
                                        marginRight: '40px',
                                        cursor: hideClose ? 'default' : 'pointer',
                                    }, onClick: onClose, fontSize: "medium" })] }))] })), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ sx: {
                        overflow: overflow,
                        flex: 1,
                    } }, { children: children })), (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ p: 2, direction: "row", justifyContent: "space-between", alignItems: "flex-end" }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ sx: { fontSize: '10px' } }, { children: id })), (0, jsx_runtime_1.jsxs)(Stack_1.default, { children: [footer, genericSaveButtons && ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ style: { width: '211px' }, variant: "outlined", color: "redWarning", onClick: function () { return genericSaveButtons.delete(); }, "data-testid": "deleteGroupBtn" }, { children: t('ds.delete') })), (0, jsx_runtime_1.jsx)(EditAndSaveButtons_1.default, { forceEditMode: genericSaveButtons.edit, isLoading: false, cancelBtnTitle: t('ds.cancel'), cancelBtnAction: function () {
                                                genericSaveButtons.cancel();
                                            }, saveBtnTitle: t('ds.save changes'), saveBtnAction: function () {
                                                genericSaveButtons.save();
                                            }, editBtnTitle: t('ds.edit'), editBtnAction: function () { return genericSaveButtons.setEdit(true); }, disabled: genericSaveButtons.disabled })] }))), (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ sx: { fontSize: '10px' } }, { children: nextSync }))] })] }))] })) })));
}
exports.default = PopIn;
PopIn.defaultProps = {
    sx: {},
    footer: null,
    id: '',
    nextSync: '',
    hideClose: false,
    overflow: 'auto',
    genericSaveButtons: undefined,
};
//# sourceMappingURL=PopIn.js.map